import { InjectionKey, Ref } from "vue";
import { Customer } from "@/@types/global";

export const CustomerKey: InjectionKey<Ref<Customer | undefined>> = Symbol("customerData");
